
const Institucional = () => {
  return (
    <section id="institucional" className="container container-institucional">
      <div className="row">
        <div className="col-lg-6 col-md-7">
          <div className="texto-institucional-home">
            <h2 className="color-red">Institucional</h2>
            <h3 className="color-dark-blue">Conheça o SeCuidaê</h3>
            <p>
              O SeCuidaê nasceu com o propósito de facilitar o acesso a serviços
              de saúde e bem-estar para todos, especialmente para quem não
              possui um plano de saúde tradicional. NÃO SOMOS UM PLANO DE SAÚDE
              OU SEGURO SAÚDE, mas sim uma alternativa inovadora que oferece
              soluções inteligentes, garantindo aos nossos associados uma ampla
              variedade de serviços de saúde e bem-estar com qualidade e custos
              acessíveis. Também disponibilizamos benefícios em seguros e
              assistências, sempre pensando no cuidado com sua família ou
              colaboradores da sua empresa. Nosso compromisso é promover
              segurança, tranquilidade e qualidade de vida para todos. Cuidar é
              o maior benefício.
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-md-5">
          <img
            src={`${process.env.REACT_APP_PUBLIC_URL}imagens/instituicional-home-new.png`}
            className="img-institucional-home img-fluid"
          />
        </div>
      </div>
    </section>
  );
};

export default Institucional;
